import { render, staticRenderFns } from "./orderBatchFinance.vue?vue&type=template&id=03754af2"
import script from "./orderBatchFinance.vue?vue&type=script&lang=js"
export * from "./orderBatchFinance.vue?vue&type=script&lang=js"
import style0 from "./orderBatchFinance.vue?vue&type=style&index=0&id=03754af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports